/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum SegmentedButtonDisplayModeEnum {
    BASE =  'base',
    VIEW = 'view',
    EDIT = 'edit'
}
